export const formatAlt = (altFull: string) => {
  let altFormat = 'not set'
  let idFormat = 'not set'
  let positionFormat = 'not set'
  let creativeFormat = 'not set'
  let nameFormat = 'not set'

  if (!altFull || altFull === '') {
    return {
      altFormat,
      idFormat,
      positionFormat,
      creativeFormat,
      nameFormat,
    }
  }

  const isAltPlain = !altFull?.includes('&')

  if (isAltPlain) {
    altFormat = altFull

    return {
      altFormat,
      idFormat,
      positionFormat,
      creativeFormat,
      nameFormat,
    }
  }

  const altClean = altFull
    ?.replaceAll('&', '')
    ?.replaceAll('|', '')
    ?.replaceAll('"', '')

  const altStart = Number(altClean?.lastIndexOf('alt=')) + 4
  const altEnd = altClean?.lastIndexOf('id=')

  altFormat = altClean?.slice(altStart, altEnd)

  const idStart = Number(altClean?.lastIndexOf('id=')) + 3
  const idEnd = altClean?.lastIndexOf('position=')

  idFormat = altClean?.slice(idStart, idEnd)

  const positionStart = Number(altClean?.lastIndexOf('position=')) + 9
  const positionEnd = altClean?.lastIndexOf('creative=')

  positionFormat = altClean?.slice(positionStart, positionEnd)

  const creativeStart = Number(altClean?.lastIndexOf('creative=')) + 9
  const creativeEnd = altClean?.lastIndexOf('name=')

  creativeFormat = altClean?.slice(creativeStart, creativeEnd)

  const nameStart = Number(altClean?.lastIndexOf('name=')) + 5

  nameFormat = altClean?.slice(nameStart)

  return {
    altFormat,
    idFormat,
    positionFormat,
    creativeFormat,
    nameFormat,
  }
}
